var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPsData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20360 -1963)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20360 1963)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20351.348 1968.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2193.058,3994.571c-.453-.03-.489-.222-.487-.588.011-2.917.006-5.835.006-8.753v-1.542q0-3.63,0-7.261c0-.9-.287-1.328-1.052-1.422-.479-.059-.59-.248-.57-.693.031-.7-.167-.877-.876-.881-1.194-.008-2.388-.019-3.581.006-.408.008-.579-.09-.62-.53a1.047,1.047,0,0,0-1.131-1.066,1.078,1.078,0,0,0-1.108,1.108c-.023.417-.189.489-.549.484-1.243-.015-2.487-.011-3.73,0-.567,0-.776.218-.805.779a1.18,1.18,0,0,1-.013.393c-.061.134-.191.33-.3.335-1.01.041-1.293.752-1.291,1.59.015,5.819.006,11.638.014,17.457,0,.364-.027.564-.489.579a1.078,1.078,0,0,0-1.069,1.188,1.178,1.178,0,0,0,1.212,1.066q8.131,0,16.263,0a1.076,1.076,0,0,0,1.21-1.035A1.059,1.059,0,0,0-2193.058,3994.571Zm-3.3-.021q-5-.024-10,0c-.379,0-.518-.088-.518-.5q.02-8.155,0-16.312c0-.368.108-.49.479-.488q5.048.015,10.1,0c.4,0,.462.156.46.5l0,16.262C-2195.83,3994.417-2195.935,3994.552-2196.357,3994.549Z",
    transform: "translate(2210.711 -3971.84)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2155.954,4091.763q0,.572,0,1.144c0,.425-.181.723-.627.739-.826.03-1.654.044-2.479.022a.714.714,0,0,1-.716-.8c-.014-.729-.02-1.459,0-2.188.017-.594.278-.833.874-.842.7-.009,1.393-.011,2.089,0,.637.01.859.246.859.876Q-2155.953,4091.242-2155.954,4091.763Z",
    transform: "translate(2164.856 -4078.094)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2159.312,4039.694c-.886,0-.962-.094-.817-1a1.168,1.168,0,0,1,1.587-.66.4.4,0,0,1,.113.256,4.267,4.267,0,0,1,.011.494C-2158.413,4039.88-2158.414,4039.674-2159.312,4039.694Z",
    transform: "translate(2165.215 -4031.329)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2158,4061.168c0,.813,0,.813-.594.815-.923,0-1.129-.2-1.13-1.086,0-.586,0-.586.964-.585C-2158,4060.312-2158,4060.312-2158,4061.168Z",
    transform: "translate(2164.797 -4051.509)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2090.085,4040.375c-.972-.012-.833.116-.842-.95-.007-.764,0-.764.583-.764.913,0,1.14.225,1.137,1.141C-2089.209,4040.375-2089.209,4040.375-2090.085,4040.375Z",
    transform: "translate(2102.848 -4032.011)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2137.633,4062.021v-1.66c.466,0,.922,0,1.377,0,.073,0,.208.06.208.093a4.238,4.238,0,0,1-.061,1.209c-.052.17-.428.286-.677.341A4.1,4.1,0,0,1-2137.633,4062.021Z",
    transform: "translate(2144.904 -4051.551)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2111.283,4040.375c-.872,0-.872,0-.873-.626,0-.891.2-1.093,1.112-1.088.566,0,.566,0,.566.977C-2110.479,4040.375-2110.479,4040.375-2111.283,4040.375Z",
    transform: "translate(2121.963 -4032.011)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2111.3,4060.312c.96,0,.811-.048.819.936.006.737,0,.737-.67.735-.846,0-1.005-.165-1.007-1.022C-2112.157,4060.311-2112.157,4060.311-2111.3,4060.312Z",
    transform: "translate(2121.963 -4051.509)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2090.058,4060.311c.9,0,.984.111.835,1-.085.51-.4.671-.875.676-.824.008-.824.019-.824-.785v-.049C-2090.915,4060.242-2091.033,4060.314-2090.058,4060.311Z",
    transform: "translate(2102.843 -4051.507)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2137.922,4039.224c0-.918,0-.918.895-.835a.716.716,0,0,1,.761.833c-.009.985.164.875-.85.876C-2138.077,4040.1-2137.9,4040.192-2137.922,4039.224Z",
    transform: "translate(2145.167 -4031.736)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPsData);
export default __webpack_public_path__ + "static/media/icon-ps-data.741ad2a1.svg";
export { ForwardRef as ReactComponent };